/** Product and company names that must keep literal "IPAC". */
export const PROTECTED_BRAND_LITERALS = [
    'IPAC Consulting',
    'IPAC Dashboard',
    'IPAC LearnDash',
    'Logo IPAC Dashboard',
    'Logo IPAC',
];

export const PROTECTED_BRAND_PATTERNS = PROTECTED_BRAND_LITERALS.map(
    (literal) => new RegExp(literal.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g')
);

const FR_CLINICAL_REPLACEMENTS = [
    [/\bSterilization Centre\b/gi, 'URDM'],
    [/\bSterilization Center\b/gi, 'URDM'],
    [/\bWHMIS\b/g, 'SIMDUT'],
    [/\bOHCW\b/g, 'Personnel dentaire'],
    [/\bMIFUs\b/g, 'IFU'],
    [/\bMiFUs\b/g, 'IFU'],
    [/\bMIFU\b/g, 'IFU'],
    [/\bMiFU\b/g, 'IFU'],
    [/\bSDS\b/g, 'FDS'],
    [/\bIPAC\b/g, 'PCI'],
];

const maskProtectedBrands = (value) => {
    const placeholders = new Map();
    let masked = value;

    PROTECTED_BRAND_LITERALS.forEach((literal, index) => {
        const token = `\u0000FRTERMS${index}\u0000`;
        if (masked.includes(literal)) {
            masked = masked.split(literal).join(token);
            placeholders.set(token, literal);
        }
    });

    return { masked, placeholders };
};

const unmaskProtectedBrands = (value, placeholders) => {
    let result = value;
    placeholders.forEach((literal, token) => {
        result = result.split(token).join(literal);
    });
    return result;
};

/** Apply Quebec/Ontario fr-CA clinical terminology to display copy. */
export function applyFrClinicalTerminology(value) {
    if (typeof value !== 'string' || value === '') {
        return value;
    }

    const { masked, placeholders } = maskProtectedBrands(value);
    let result = masked;

    FR_CLINICAL_REPLACEMENTS.forEach(([pattern, replacement]) => {
        result = result.replace(pattern, replacement);
    });

    return unmaskProtectedBrands(result, placeholders);
}

/** Strip protected brands before linting fr copy for clinical IPAC usage. */
export function stripProtectedBrandsForLint(value) {
    if (typeof value !== 'string') {
        return value;
    }

    let stripped = value;
    PROTECTED_BRAND_LITERALS.forEach((literal) => {
        stripped = stripped.split(literal).join(' ');
    });
    return stripped;
}
